module.exports = __webpack_public_path__ + "static/img/9.92df341.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/9.png
// module id = EEB+
// module chunks = 0